import styled from "styled-components";

export const Wrapper = styled.div``;

export const PairTitle = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  .coins {
    display: flex;
    & > div:nth-child(2) {
      margin-left: -16px;
    }
  }
  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    width: 100%;
  }
`;

export const Lent = styled.div`
  position: relative;
  border-radius: var(--rounding-radius-xxs, 4px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  height: 8px;
  .painted {
    border-radius: var(--rounding-radius-xxs, 4px);
    background: var(--fill-accent-primary, #9fe);
    position: absolute;
    left: 0;
    top: 0;
    width: 30%;
    height: 100%;
  }
`;
